import React, { useEffect } from 'react'
import { useEvent } from '@fs/zion-frontend-friends'
import { usePageView } from '@fs/zion-analytics'
import { Title } from '@fs/zion-head'
import { useTranslation } from 'react-i18next'
import { sortAndFilterGroups, useGroupsList } from '../services/getGroupsList'
import GroupLimitsProvider from '../providers/GroupLimitsProvider'
import GroupList, { GroupListSkeleton } from '../components/group-lists/GroupList'
import JoinGroupOverlay from '../components/join-group-overlay/JoinGroupOverlay'

export default function FamilyGroupsListPage() {
  usePageView({ page_detail: 'View List: FG' }) // page_detail updates link_page for all analytics past this point
  const [{ data, loading }, refetch] = useGroupsList()
  const [t] = useTranslation()

  const refetchGroupList = useEvent(() => refetch())

  // When routing client-side back to this list, we need to call refetch to update the list
  useEffect(() => {
    refetchGroupList()
  }, [refetchGroupList])

  const sortedGroups = sortAndFilterGroups({
    groups: data?.memberSummaries || [],
    isFamily: true,
  })

  if (loading === undefined || loading) return <GroupListSkeleton />

  return (
    <>
      <Title>{t('group-management.family-groups.heading')}</Title>
      <GroupLimitsProvider>
        <GroupList
          refetchGroupList={refetchGroupList}
          totalGroupCount={data?.memberSummaries?.length}
          groups={sortedGroups}
        />
        {/* Overlay pops up if the URL has a `groupId` and `inviteId` query params */}
        <JoinGroupOverlay onJoinGroup={refetchGroupList} />
      </GroupLimitsProvider>
    </>
  )
}
